import Component from '../Component';
import { setCookie } from '../Helpers';
import $ from '../../vendor/CustomJquery';

export default class SidebarSwitch extends Component {

  configure() {
    this.cookieTTL = 720; // In days
    return super.configure();
  }

  initialize() {

    this.switch = $('.sidebar-toggle');
    this.icon = this.switch.find('i');
    this.sidebarColumn = $('.column.sidebar');
    this.commonColumn = $('.column.is-common');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.switch.on('click', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    this.sidebarColumn.toggleClass('is-collapsed');
    this.commonColumn.toggleClass('is-expanded');

    let isSidebarCollapsed = (this.sidebarColumn.hasClass('is-collapsed'));

    if (isSidebarCollapsed) {
      this.icon.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
    } else {
      this.icon.addClass('fa-angle-double-left').removeClass('fa-angle-double-right');
    }

    setCookie('sidebar-state', (isSidebarCollapsed ? 'collapsed' : 'expanded'), this.cookieTTL);

    event.preventDefault();
  }

}